import { render, staticRenderFns } from "./SubdivisionsRemoveModal.vue?vue&type=template&id=7c528d48&scoped=true&"
import script from "./SubdivisionsRemoveModal.vue?vue&type=script&lang=js&"
export * from "./SubdivisionsRemoveModal.vue?vue&type=script&lang=js&"
import style0 from "./SubdivisionsRemoveModal.vue?vue&type=style&index=0&id=7c528d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c528d48",
  null
  
)

export default component.exports